// Toast vẫn imperative có chủ đích: nó ghi vào #toast — một element nằm
// NGOÀI React tree (khai trong index.html). Biến nó thành component sẽ cần
// context + portal cho một thứ chỉ có 2 trạng thái, không đáng.

let timer: number | undefined;

export function toast(msg: string, ok = true): void {
  const el = document.querySelector<HTMLElement>("#toast");
  if (!el) return;
  el.textContent = msg;
  el.className = `toast ${ok ? "ok" : "err"}`;
  el.hidden = false;
  clearTimeout(timer);
  timer = window.setTimeout(() => { el.hidden = true; }, 4000);
}
